<script>
	const parallaxDepthRange = [-0.5, -0.4, -0.3, -0.2, -0.1, 0.1, 0.2, 0.3, 0.4, 0.5];

	export let id;

	export let color = '#ffffff';
	export let width = 0;
	export let height = 0;
	export let top = 'auto';
	export let left = 'auto';
	export let rotate = 0;
	export let maxWidth = 'auto';
	export let minWidth = 'auto';
	export let parallaxDepth = parallaxDepthRange[Math.floor(Math.random() * parallaxDepthRange.length)];
</script>

<div data-depth={parallaxDepth} id="{id}">
	<svg width="271" height="256" viewBox="0 0 271 256" fill="none"
		 xmlns="http://www.w3.org/2000/svg"
		 style="--width: {width}; --height: {height}; --top: {top}; --left: {left}; --color: {color}; --rotate: {rotate}; --max-width: {maxWidth}; --min-width: {minWidth}">
		<path d="M135.5,0,0,97.8,51.8,256H219.2L271,97.8Z" fill="{color}"/>
	</svg>
</div>

<style type="text/scss">
	div {
		height: 100%;
		width: 100%;
	}

	svg {
		position: absolute;
		width: var(--width);
		height: var(--height);
		top: calc(50vh + var(--top));
		left: calc(50vw + var(--left));
		transform: translate(-50%, -50%);
		transform-origin: center center;
		max-width: var(--max-width);
		min-width: var(--min-width);
		overflow: unset;

		path {
			animation: spin 30s linear infinite;
			fill: var(--color);
			transform-origin: center center;

			// transform-box allows us to alter the transform reference box of a particular element (similar behaviour
			// like box-sizing)
			transform-box: fill-box;
		}
	}

	@keyframes spin {
		100% {
			transform: rotate(360deg);
		}
	}
</style>
